export enum ValidatorsKeys {
  Required = 'required',
  MaxLength = 'maxlength',
  MinLength = 'minlength',
  Email = 'email',
  LargeSize = 'largeSize',
  Pattern = 'pattern',
  Telegram = 'telegram',
  Zipcode = 'zipcode',
  UniqueName = 'uniqueName',
  MinGreaterThanMax = 'minGreaterThanMax',
  MaxLessThanMin = 'maxLessThanMin',
  Max = 'max',
  Min = 'min',
  ForbiddenSymbols = 'forbiddenSymbols',
  UsernameExists = 'usernameExists',
  RoleNameExists = 'roleNameExists',
  Format = 'format',
  IncorrectFileFormat = 'incorrectFileFormat',
  InvalidUrl = 'invalidUrl',
  Range = 'range',
  CompanyName = 'companyName',
  OperatorName = 'operatorName',
  ProviderName = 'providerName',
  ProviderId = 'providerId',
  ProviderIdExists = 'providerIdExists',
  NonDefaultName = 'nonDefaultName',
  FolderNameExists = 'folderNameExists',
  SectionNameExists = 'sectionNameExists',
  NameMinLength = 'nameMinLength',
  InvalidOperatorKeyFormat = 'invalidOperatorKeyFormat',
  OperatorKeyExists = 'operatorKeyExists',
  UniqueMethod = 'uniqueMethod',
  BrandId = 'brandId',
  InvalidAssetUploadFile = 'invalidAssetUploadFile',
  InvalidAssetUploadFileFormat = 'invalidAssetUploadFileFormat',
  SpribeDomainEmail = 'spribeDomainEmail',
  InvalidJson = 'invalidJson',
  DateAfterCompared = 'dateAfterCompared',
  VendorName = 'vendorName',
  VendorId = 'vendorId',
  ArrayOverlapping = 'arrayOverlapping',
}
